import React from "react";
import { Mail, MessageSquare, Linkedin, ArrowUp } from "lucide-react";
import { personalInfo } from "../data/mock";

const navLinks = [
  { label: "Beranda", href: "#home" },
  { label: "Tentang", href: "#about" },
  { label: "Keahlian", href: "#skills" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Sertifikasi", href: "#certifications" },
  { label: "Kontak", href: "#contact" },
];

export default function Footer() {
  const nav = (href) => document.getElementById(href.replace("#",""))?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer style={{ background: "var(--bg)", borderTop: "1px solid rgba(255,255,255,0.06)", padding: "64px 32px 32px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>

        {/* Top — big CTA text editorial */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          marginBottom: 64, flexWrap: "wrap", gap: 24,
          paddingBottom: 64, borderBottom: "1px solid rgba(255,255,255,0.06)",
        }}>
          <div>
            <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: "#6a6a88", letterSpacing: 3, marginBottom: 12 }}>SIAP KOLABORASI?</div>
            <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "clamp(28px,5vw,56px)", color: "#f2f2ff", margin: 0, letterSpacing: "-2px", lineHeight: 1 }}>
              {personalInfo.domain}
            </h3>
          </div>
          <a href="#contact" onClick={e => { e.preventDefault(); nav("#contact"); }}
            style={{ display: "inline-flex", alignItems: "center", gap: 12, padding: "14px 32px", borderRadius: 3, background: "linear-gradient(135deg,#00e5ff,#9b00ff)", color: "#07070f", fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 14, textDecoration: "none", letterSpacing: 1, transition: "opacity 0.2s, transform 0.2s" }}
            onMouseEnter={e => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "translateY(-2px)"; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "none"; }}
          >
            MULAI PROYEK
          </a>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 64, marginBottom: 48 }} className="footer-grid">
          {/* Brand */}
          <div>
            <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 20, color: "#f2f2ff", marginBottom: 16, letterSpacing: "-0.5px" }}>
              EP<span style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: "#00e5ff", marginLeft: 3, verticalAlign: "middle", marginBottom: 3 }} />
            </div>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#6a6a88", lineHeight: 1.8, margin: "0 0 20px", maxWidth: 260 }}>
              Profesional IT berpengalaman di Medan. Hardware, software, dan networking.
            </p>
            <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: "#3a3a55" }}>&copy; {new Date().getFullYear()} {personalInfo.name}</div>
          </div>

          {/* Nav */}
          <div>
            <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 600, fontSize: 10, color: "#6a6a88", letterSpacing: 2, textTransform: "uppercase", marginBottom: 20 }}>Navigasi</div>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {navLinks.map(l => (
                <li key={l.label} style={{ marginBottom: 10 }}>
                  <a href={l.href} onClick={e => { e.preventDefault(); nav(l.href); }}
                    style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#6a6a88", textDecoration: "none", transition: "color 0.2s" }}
                    onMouseEnter={e => e.target.style.color = "#f2f2ff"}
                    onMouseLeave={e => e.target.style.color = "#6a6a88"}
                  >{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div style={{ fontFamily: "'DM Mono', monospace", fontWeight: 600, fontSize: 10, color: "#6a6a88", letterSpacing: 2, marginBottom: 20 }}>Kontak</div>
            <a href={`mailto:${personalInfo.email}`} style={{ display: "flex", alignItems: "center", gap: 8, fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#6a6a88", textDecoration: "none", marginBottom: 14, transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = "#00e5ff"}
              onMouseLeave={e => e.currentTarget.style.color = "#6a6a88"}
            ><Mail size={13} /> {personalInfo.email}</a>
            <div style={{ display: "flex", gap: 8 }}>
              {[
                { href: `https://wa.me/${personalInfo.whatsapp}`, icon: <MessageSquare size={15} />, hc: "#25D366" },
                { href: personalInfo.linkedin, icon: <Linkedin size={15} />, hc: "#0A66C2" },
              ].map((s, i) => (
                <a key={i} href={s.href} target="_blank" rel="noreferrer"
                  style={{ width: 36, height: 36, borderRadius: 3, border: "1px solid rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "center", color: "#6a6a88", textDecoration: "none", transition: "all 0.2s" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = s.hc; e.currentTarget.style.color = s.hc; e.currentTarget.style.background = `${s.hc}10`; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; e.currentTarget.style.color = "#6a6a88"; e.currentTarget.style.background = "transparent"; }}
                >{s.icon}</a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 24, borderTop: "1px solid rgba(255,255,255,0.05)" }}>
          <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: "#3a3a55" }}>DIBUAT DENGAN PASSION UNTUK TEKNOLOGI INDONESIA.</span>
          <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} style={{ width: 36, height: 36, borderRadius: 3, border: "1px solid rgba(255,255,255,0.08)", background: "none", color: "#6a6a88", cursor: "none", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(0,229,255,0.4)"; e.currentTarget.style.color = "#00e5ff"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; e.currentTarget.style.color = "#6a6a88"; }}
          ><ArrowUp size={15} /></button>
        </div>
      </div>
    </footer>
  );
}
